var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-card",
    {
      ref: "tableContainer",
      staticClass: "width-100 relative",
      attrs: { flat: "" },
    },
    [
      _c("v-card-text", [
        _c(
          "div",
          [
            _c(
              "div",
              {
                staticClass: "d-flex mb-2 justify-center",
                staticStyle: { border: "1px solid #d2d2d2" },
              },
              [
                _c("h2", { staticClass: "text-center" }, [
                  _vm._v("Connection Circuit Diagram"),
                ]),
              ]
            ),
            _c("div", {
              staticClass: "gojs-panel d-flex justify-center mt-4",
              staticStyle: { "min-height": "500px" },
              attrs: { id: "gojsConnectionPanel" },
            }),
            _vm.selectedCable
              ? _c(
                  "div",
                  { staticClass: "mt-6" },
                  [
                    _c("CableDetailsFormComponent", {
                      attrs: {
                        "selected-connection-id": _vm.selectedConnectionId,
                        "selected-cable": _vm.selectedCable,
                        readonly: _vm.isReadonly,
                      },
                      on: {
                        "cable-created": _vm.onCableCreated,
                        "cable-updated": _vm.onCableUpdated,
                        "form-reset": _vm.onFormReset,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm.selectedCore
              ? _c(
                  "div",
                  { staticClass: "mt-6" },
                  [
                    _c("CoreDetailsFormComponent", {
                      attrs: {
                        "selected-connection-id": _vm.selectedConnectionId,
                        "selected-core": _vm.selectedCore,
                        "available-cables": _vm.availableCables,
                        readonly: _vm.isReadonly,
                      },
                      on: {
                        "core-created": _vm.onCoreCreated,
                        "core-updated": _vm.onCoreUpdated,
                        "form-reset": _vm.onCoreFormReset,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm.selectedPin
              ? _c(
                  "div",
                  { staticClass: "mt-6" },
                  [
                    _c("PinDetailsFormComponent", {
                      attrs: {
                        "selected-location-id": _vm.selectedPin.locationId,
                        "selected-pin": _vm.selectedPin,
                        readonly: _vm.isReadonly,
                      },
                      on: {
                        "pin-created": _vm.onPinCreated,
                        "pin-updated": _vm.onPinUpdated,
                        "form-reset": _vm.onPinFormReset,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _c("SelectCapDialogComponent", {
              ref: "selectCapDialogRef",
              attrs: {
                "available-in-caps": _vm.toLocationInCaps,
                "available-out-caps": _vm.fromLocationOutCaps,
              },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }